class DataStoreManager {
  constructor() {
    this.database = null;
    this.currentLocation = null;
    this.currentPanoID = null;
    this.endpoint = `${window.CONFIG.backendURL}/street-gallery-bts/sv/api/`;
  }

  get(id, onSuccess, onError) {
    fetch(this.endpoint + id, {
      method: 'get',
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (onSuccess) {
          onSuccess(data.data);
        }
      })
      .catch(function (error) {
        console.log('Request failed', error);
        if (onError) {
          onError(null);
        }
      });
  }

  uploadImage(base64Image, onSuccess) {
    const splitted = base64Image.split(',');
    const ext = base64Image.split(';')[0].split('/')[1];

    base64Image = splitted[1];
    const url = `${this.endpoint}image/add`;

    fetch(url, {
      method: 'POST',
      body: JSON.stringify({ ext, base64Image }),
      cache: 'no-cache',
      headers: new Headers({
        'content-type': 'application/json',
      }),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (onSuccess) {
          onSuccess(data);
        }
      });
  }

  save(data = {}, camParams = {}, pano, location, onSuccess = null) {
    const entity = {
      active: false,
      location,
      pano,
      data,
      camParams,
    };

    const url = `${this.endpoint}create`;

    fetch(url, {
      method: 'POST',
      body: JSON.stringify(entity),
      cache: 'no-cache',
      headers: new Headers({
        'content-type': 'application/json',
      }),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (onSuccess) onSuccess(data.uuid);
      });
  }
}
export default DataStoreManager;
